"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeatureFlagsService = void 0;
const react_1 = require("react");
const context_1 = require("../context");
const useFeatureFlagsService = () => {
    const { featureFlagsService } = (0, react_1.useContext)(context_1.EnrichContext);
    return { featureFlagsService };
};
exports.useFeatureFlagsService = useFeatureFlagsService;
exports.default = exports.useFeatureFlagsService;
